<div [ngBusy]="{busy: deliveryCheckerBusy, message: ('common.pleaseWait' | translate)}">
  <div class="py-5" *ngIf="!selectedCake">
    <ui-gif-loader [text]="'cakeBuilder.pleaseWait' | translate"></ui-gif-loader>
  </div>

  <i class="icon-close p-3 d-none d-md-inline-block" (click)="modal.dismiss()"></i>
  <cake-builder
    *ngIf="selectedCake && (cartLine$ | async)"
    [cake]="selectedCake"
    [upsellProductTypes]="upsellProductTypes()"
    [disabledScrollingToSection]="false"
    [bakeryUrl]="navigationService.getLocationUrl({name: selectedCake.bakery.name})"
    [cartLine]="cartLine$ | async"
    [cartLines]="cartLines$ | async"
    [upsellCartLines]="(upsellCartLines$ | async)"
    [cakeSaving]="lineSaving"
    [showSubmitButtonsAsSticky]="false"
    [showCustomNote]="true"
    [noteContext]="CUSTOM_NOTE_CONTEXT"
    (onLineUpdated)="updateEditingSession($event)"
    (onBakeryNameClicked)="navigationService.goToProductsOverview(selectedCake.bakery.name)"
    (onBack)="modal.dismiss()"
    (onSubmit)="save($event)"
    (onCheckDelivery)="showDeliveryChecker($event)">

    <ui-message class="d-block my-3 content-area-after-cake-info"
                *ngIf="isSharedBusinessAccount && selectedCake.bakery.payInStoreMarketplaceOnlyMethod"
                [type]="'error'">
      {{ 'orderProcess.payment.possibleToPayWhenPickingUp' | translate: { bakeryName: selectedCake.bakery.name } }}
    </ui-message>

  </cake-builder>
</div>
